<template>
	<EMCoreTemplate category="OSMLife" identity="transactionHistory" entity="osm_policy_rider"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/TransactionHistory.vue